import { create } from 'zustand';

// Mock user for demo
const DEMO_USERS = {
  'admin@blum.com': {
    password: 'admin123',
    user: { _id: '1', name: 'Admin User', firstName: 'Admin', lastName: 'User', email: 'admin@blum.com', phone: '+91 9876543210', role: 'admin', status: 'Active', createdAt: new Date().toISOString() }
  },
  'owner@blum.com': {
    password: 'owner123',
    user: { _id: '2', name: 'Rajesh Kumar', firstName: 'Rajesh', lastName: 'Kumar', email: 'owner@blum.com', phone: '+91 9876543211', role: 'owner', status: 'Active', createdAt: new Date().toISOString() }
  },
  'sales@blum.com': {
    password: 'sales123',
    user: { _id: '3', name: 'Priya Sharma', firstName: 'Priya', lastName: 'Sharma', email: 'sales@blum.com', phone: '+91 9876543212', role: 'sales_executive', status: 'Active', createdAt: new Date().toISOString() }
  },
  'manager@blum.com': {
    password: 'manager123',
    user: { _id: '4', name: 'Arun Singh', firstName: 'Arun', lastName: 'Singh', email: 'manager@blum.com', phone: '+91 9876543213', role: 'store_incharge', status: 'Active', createdAt: new Date().toISOString() }
  },
  'designer@blum.com': {
    password: 'design123',
    user: { _id: '5', name: 'Meera Patel', firstName: 'Meera', lastName: 'Patel', email: 'designer@blum.com', phone: '+91 9876543214', role: 'designer', status: 'Active', createdAt: new Date().toISOString() }
  },
  'pm@blum.com': {
    password: 'pm123',
    user: { _id: '6', name: 'Vikram Nair', firstName: 'Vikram', lastName: 'Nair', email: 'pm@blum.com', phone: '+91 9876543215', role: 'designer', status: 'Active', createdAt: new Date().toISOString() }
  },
  'inventory@blum.com': {
    password: 'inv123',
    user: { _id: '7', name: 'Suresh Reddy', firstName: 'Suresh', lastName: 'Reddy', email: 'inventory@blum.com', phone: '+91 9876543216', role: 'store_incharge', status: 'Active', createdAt: new Date().toISOString() }
  },
  'accounts@blum.com': {
    password: 'acc123',
    user: { _id: '8', name: 'Anita Joshi', firstName: 'Anita', lastName: 'Joshi', email: 'accounts@blum.com', phone: '+91 9876543217', role: 'accountant', status: 'Active', createdAt: new Date().toISOString() }
  },
};

export const useAuthStore = create((set, get) => ({
  user: null,
  token: null,
  isAuthenticated: false,

  login: (user, token) => {
    localStorage.setItem('blum_token', token);
    localStorage.setItem('blum_user', JSON.stringify(user));
    set({ user, token, isAuthenticated: true });
  },

  logout: () => {
    localStorage.removeItem('blum_token');
    localStorage.removeItem('blum_user');
    set({ user: null, token: null, isAuthenticated: false });
  },

  hasRole: (roles) => {
    const { user } = get();
    return user ? roles.includes(user.role) : false;
  },
}));

export { DEMO_USERS };

// Rehydrate from localStorage
const storedToken = localStorage.getItem('blum_token');
const storedUser = localStorage.getItem('blum_user');
if (storedToken && storedUser) {
  try {
    const user = JSON.parse(storedUser);
    useAuthStore.getState().login(user, storedToken);
  } catch {}
}
